"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDateToMonthYearString = transformDateToMonthYearString;
const transformDateToMonthNameString_1 = require("./transformDateToMonthNameString");
function transformDateToMonthYearString(date) {
    const dateToString = new Date(date);
    const year = dateToString.getUTCFullYear().toString();
    const month = (0, transformDateToMonthNameString_1.transformDateToMonthNameString)(dateToString);
    return `${month}, ${year}`;
}
//# sourceMappingURL=transformDateToMonthYearString.js.map